module.exports = __webpack_public_path__ + "img/title.97cf05e3.png";